import chartTitles from '../chartTitles'
import withToolbar from '../withToolbar'
import LineChart from './LineChart'

export default withToolbar(LineChart, {
  pdfExport: {
    title: 'Weight Chart'
  },
  timeWindow: 7 * 12,
  childProps: {
    title: chartTitles.weight,
    type: 'weight',
    yAxisLabel: 'Weight (kg)'
  }
})
